import type { JSX } from 'react';
import { Pencil, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ExperienceCardActionsProps {
  onEdit: () => void;
  onDelete: () => void;
  isEditable: boolean;
  editDisabledReason?: string;
  isDeletable?: boolean;
  deleteDisabledReason?: string;
}

export function ExperienceCardActions({
  onEdit,
  onDelete,
  isEditable,
  editDisabledReason,
  isDeletable = true,
  deleteDisabledReason,
}: ExperienceCardActionsProps): JSX.Element {
  return (
    <div className="flex shrink-0 gap-2">
      <Button
        variant="outline"
        size="sm"
        onClick={onEdit}
        disabled={!isEditable}
        title={isEditable ? undefined : editDisabledReason}
      >
        <Pencil className="mr-1 h-4 w-4" aria-hidden="true" />
        Edit
      </Button>
      <Button
        variant="destructive"
        size="sm"
        onClick={onDelete}
        disabled={!isDeletable}
        title={isDeletable ? undefined : deleteDisabledReason}
      >
        <Trash2 className="mr-1 h-4 w-4" aria-hidden="true" />
        Delete
      </Button>
    </div>
  );
}
